/* PROJ-116 (24.10.2026): Schmuck-Editoren auf der Produktseite, Muster Fußabdruck-PDP (abdruck-pdp.js).
   Der Editor liegt als eigene, versteckte Section in der Vorlage (pdp_embed). Beim Start:
     1. Bedienfeld (.main__switcher) in die Kaufbox ([data-spdp-panel]), Bühne (.buehne) ins aktive Galeriebild,
        beide in einem Wrapper mit den Editor-Klassen, damit jewelry.css weiter greift.
     2. Erst dann die Editor-Skripte nachladen (type="text/x-schmuck-pdp"): nichts Schweres vor dem Klick.
     3. Theme-Formular abfangen -> Knopf des Editors (#atc-btn) klicken: Gates, Properties, Warenkorb, Drawer
        bleiben zu 100 % die des Editors, das Bestellformat ändert sich nicht.
     4. Farbe: Theme-Varianten-Wechsel klickt die passende Editor-Kachel (.swatch[data-farbe]).
   Der Varianten-Wechsel baut die Kaufbox neu auf: die herausgelösten Knoten überleben (Referenzen) und werden in
   den neuen Kasten zurückgesetzt. */
(function () {
  'use strict';
  const SP = window.__dlSchmuckPdp || (window.__dlSchmuckPdp = {
    gestartet: false, panel: null, buehne: null, wrapPanel: null, wrapBuehne: null, fehler: [], extra: [],
    cfg: null, lauscher: false, versuche: 0, sticky: false, raf: false, farbeAktuell: 'silber', fehlerAktiv: false, nachStart: [],
  });
  const q = (s, r) => (r || document).querySelector(s);
  /* Lucide rotate-3d (lucide-static v1.45.0, ISC), Zeichen für Zeichen, wie snippets/icon-lucide-rotate-3d.liquid */
  const ICON_DREHEN = '<svg class="spdp-drehen__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m15.194 13.707 3.814 1.86-1.86 3.814"/><path d="M16.47214 7.52786 A 5 10 0 1 0 13 21.79796"/><path d="M21.79796 11 A 10 5 0 1 0 19 15.57071"/></svg>';
  function cfg() {
    const el = q('[data-schmuck-pdp-cfg]');
    if (el) { try { SP.cfg = JSON.parse(el.textContent); } catch (e) { /* alte cfg bleibt */ } }
    return SP.cfg;
  }
  function sektion() { const m = q('[data-schmuck-pdp-marker]'); return m && (m.closest('.shopify-section') || m.parentElement); }
  function container() { return q('[data-spdp-panel]'); }
  function statusEl() { return q('[data-spdp-status]'); }
  function status(text, ok) { const s = statusEl(); if (!s) return; s.textContent = text; s.classList.toggle('ist-ok', !!ok); }

  /* ---- Theme-Formular + Variante ---- */
  function istUnserFormular(f) { const id = f && f.querySelector && f.querySelector('[name="id"]'); const c = SP.cfg; return !!(id && c && c.varianten[String(id.value)]); }
  function themeForm() { for (const f of document.querySelectorAll('form[action*="/cart/add"]')) if (istUnserFormular(f)) return f; return null; }
  function varianteId() { const f = themeForm(); const c = SP.cfg || { varianten: {} }; return f ? String(f.querySelector('[name="id"]').value) : Object.keys(c.varianten)[0]; }
  function farbe() { const v = (SP.cfg && SP.cfg.varianten[varianteId()]) || {}; return /gold/.test(v.farbe || '') ? 'gold' : 'silber'; }
  /* Der Editor merkt sich die Farbe in seinem Zustand; die 'current'-Klassen pflegt er nur innerhalb seiner (nun
     leeren) Section, darum führen wir die Klassen und den letzten Stand selbst. */
  function farbeSyncen() {
    if (!SP.panel) return;
    const soll = farbe();
    const sw = SP.panel.querySelector('.swatch[data-farbe="' + soll + '"]');
    if (!sw) return;
    if (SP.farbeAktuell !== soll) { sw.click(); SP.farbeAktuell = soll; }
    SP.panel.querySelectorAll('.swatch[data-farbe]').forEach((x) => x.classList.toggle('current', x.dataset.farbe === soll));
  }

  /* ---- Galerie ---- */
  function activeSlide() {
    const media = ((SP.cfg && SP.cfg.varianten[varianteId()]) || {}).media;
    return (media && q('.product-gallery__media[data-media-id="' + media + '"]'))
      || q('.product-gallery__media[data-variant-media="true"]')
      || q('.product-gallery__media');
  }
  function wrapper(root, extraKlasse) {
    const w = document.createElement('div');
    w.className = 'spdp-wrap ' + extraKlasse + ' ' + (root ? root.className : 'dm-jewelry');
    if (root) for (const k of Object.keys(root.dataset)) w.dataset[k] = root.dataset[k];
    return w;
  }
  function teileHolen() {
    if (SP.panel) return true;
    const s = sektion();
    if (!s) return false;
    const root = s.querySelector('.dm-jewelry') || s.querySelector('[class*="dm-jewelry"]');
    SP.panel = s.querySelector('.main__switcher');
    SP.buehne = s.querySelector('.buehne');
    if (!root || !SP.panel || !SP.buehne) { SP.panel = null; return false; }
    /* Das Editor-Root (wrap = .dm-jewelry--x in den Editor-Skripten) wandert als Ganzes in die Kaufbox, damit alle
       wrap.querySelector-Aufrufe der Editoren (current-Klassen, Rückseiten-Modus, Hilfe) weiter treffen. Nur die
       Bühne geht in die Galerie, die Modale in den body. */
    SP.wrapPanel = root;
    root.classList.add('spdp-wrap', 'spdp-wrap--panel');
    SP.wrapBuehne = wrapper(root, 'spdp-wrap--buehne');
    SP.wrapBuehne.classList.remove('spdp-wrap--panel');
    SP.wrapBuehne.appendChild(SP.buehne);
    /* 25.10.2026 (Dominik: „statt Vorderseite/Rückseite einfach dieses 360°-Drehbare, so wie bei Momenterie“): Hinweis
       statt Seiten-Knöpfe. Drehen per Finger/Maus macht die Bühne selbst, beim Ausfüllen der Rückseite dreht der
       Editor sie weiter von allein. Gleicher Hinweis auf der Fußabdruck-PDP (snippets/abdruck-pdp.liquid). */
    const hinweis = document.createElement('div');
    hinweis.className = 'spdp-drehen';
    hinweis.innerHTML = ICON_DREHEN + '<span class="spdp-drehen__text"><strong>Live-Vorschau</strong><span class="spdp-drehen__punkt"> · </span><span>360° drehbar</span></span>';
    SP.wrapBuehne.appendChild(hinweis);
    /* 25.10.2026: solange Pflichtfelder leer sind, zeigt der Editor das Design des Produktfotos (jewelry-beispiel.js).
       Hinweis darauf wie bei der Fußabdruck-PDP (apdp-stage__hinweis), nicht bei den Abdruck-Editoren (eigener Hinweis). */
    if (!SP.buehne.querySelector('.abdruck-beispiel-badge')) {
      const bsp = document.createElement('p');
      bsp.className = 'spdp-beispiel';
      bsp.textContent = 'Beispiel. Deine Gravur erscheint, sobald du deine Angaben einträgst.';
      SP.wrapBuehne.appendChild(bsp);
    }
    /* Modale (Zuschnitt-Dialog usw., position: fixed) müssen aus der versteckten Section heraus */
    const modale = [...root.children].filter((el) => /backdrop|modal/.test(el.className || ''));
    if (modale.length) { SP.wrapModale = wrapper(root, 'spdp-wrap--modale'); modale.forEach((el) => SP.wrapModale.appendChild(el)); document.body.appendChild(SP.wrapModale); }
    SP.fehler = ['#atc-fehler', '#cta-fehler'].map((id) => s.querySelector(id)).filter(Boolean);
    SP.extra = ['#abdruck-wiederholen'].map((id) => s.querySelector(id)).filter(Boolean);
    return true;
  }
  function panelEinsetzen() {
    const c = container();
    if (!c || !teileHolen()) return;
    if (SP.wrapPanel.parentNode !== c) c.appendChild(SP.wrapPanel);
    c.hidden = false;
    const st = q('[data-spdp-start]');
    if (st) st.hidden = true;
    status('Gestaltung läuft', false);   /* der Startkasten wird beim Varianten-Wechsel neu gerendert */
    const fe = q('[data-spdp-fehler]');
    if (fe) SP.fehler.concat(SP.extra).forEach((el) => { if (el.parentNode !== fe) fe.appendChild(el); });
  }
  function buehneEinsetzen() {
    if (!SP.wrapBuehne) return;
    const slide = activeSlide();
    if (!slide) { if (SP.versuche++ < 20) setTimeout(buehneEinsetzen, 250); else SP.versuche = 0; return; }
    SP.versuche = 0;
    if (SP.wrapBuehne.parentNode !== slide) {
      const alt = q('.product-gallery__media.spdp-slide');
      if (alt && alt !== slide) alt.classList.remove('spdp-slide');
      slide.classList.add('spdp-slide');
      slide.appendChild(SP.wrapBuehne);
      setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
    }
    const gal = slide.closest('.product-gallery');
    if (gal) { gal.classList.add('spdp-galerie-fixiert'); stickyEndeStarten(gal); }
    const sc = slide.closest('.product-gallery__carousel');
    if (sc) sc.scrollLeft = 0;
  }
  /* Mobil: Leiste klebt bis zur Statuszeile, danach schiebt sie sich mit dem Inhalt weg.
     25.10.2026 (Dominik: „wackelt dieser Coin so komisch … je schneller ich nach oben schiebe, desto tiefer rutscht
     er“): vorher schob ein Scroll-Handler die Leiste per transform nach oben. Safari scrollt auf dem Compositor und
     liefert Scroll-Ereignisse verzoegert, der Handler lief der Seite hinterher: Wackeln, bei schnellem Wischen mehr.
     Jetzt rechnet der Browser selbst: ein Rahmen (.spdp-sticky-rahmen) um die Galerie reicht genau bis 8 px ueber die
     Statuszeile, die Galerie klebt darin (position: sticky) und loest sich am Rahmenende ohne Skript. Der Rahmen
     belegt im Grid nur die Hoehe der Galerie (negativer margin-bottom) und laesst Klicks durch. Neu gerechnet wird
     nur bei Groessenaenderung (ResizeObserver, resize), nie beim Scrollen. Desktop: display: contents (wie vorher). */
  function stickyEndeStarten(gal) {
    if (SP.sticky) return;
    SP.sticky = true;
    const mq = window.matchMedia('(max-width: 999px)');
    let rahmen = gal.parentElement && gal.parentElement.classList.contains('spdp-sticky-rahmen') ? gal.parentElement : null;
    if (!rahmen) {
      rahmen = document.createElement('div');
      rahmen.className = 'spdp-sticky-rahmen';
      gal.parentNode.insertBefore(rahmen, gal);
      rahmen.appendChild(gal);
    }
    let tick = false;
    const rechnen = () => {
      tick = false;
      const st = statusEl();
      if (!mq.matches || !st || !gal.classList.contains('spdp-galerie-fixiert')) { rahmen.style.height = ''; rahmen.style.marginBottom = ''; return; }
      const oben = rahmen.getBoundingClientRect().top;
      const h = Math.round(st.getBoundingClientRect().top - 8 - oben);
      const g = gal.offsetHeight;
      if (h > g) { rahmen.style.height = h + 'px'; rahmen.style.marginBottom = (g - h) + 'px'; }
      else { rahmen.style.height = ''; rahmen.style.marginBottom = ''; }
    };
    const anfordern = () => { if (!tick) { tick = true; requestAnimationFrame(rechnen); } };
    window.addEventListener('resize', anfordern);
    if (mq.addEventListener) mq.addEventListener('change', anfordern);
    if (typeof ResizeObserver === 'function') {
      const ro = new ResizeObserver(anfordern);
      ro.observe(gal);
      const info = q('.product-info') || document.body;
      ro.observe(info);
    }
    anfordern();
  }

  /* ---- Skripte erst beim Start ---- */
  function skripteLaden() {
    document.querySelectorAll('script[type="text/x-schmuck-pdp"]').forEach((s) => {
      const n = document.createElement('script');
      if (s.dataset.type === 'module') n.type = 'module';
      n.src = s.dataset.src;
      document.body.appendChild(n);
      s.remove();
    });
  }
  function aufEditorWarten(fn, versuche) {
    const sek = sektion();
    const ok = sek && sek.querySelector('.swatch[data-farbe]') && sek.querySelector('#stage canvas, #stage img');
    if (ok) { setTimeout(fn, 300); return; }
    if (versuche <= 0) { fn(); return; }
    setTimeout(() => aufEditorWarten(fn, versuche - 1), 250);
  }
  function fehlerZeigen(text) {
    const fe = q('[data-spdp-fehler]');
    if (!fe) return;
    let el = fe.querySelector('[data-spdp-eigen]');
    if (!el) { el = document.createElement('div'); el.className = 'cta-fehler'; el.setAttribute('data-spdp-eigen', ''); fe.appendChild(el); }
    el.textContent = text; el.hidden = !text;
    if (text) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  /* ---- Fehlende Pflichtfelder markieren wie die Fußabdruck-PDP (abdruck-pdp.js markiereFehler) ----
     25.10.2026 (Dominik: „nicht in dem gleichen Rot wie der Fußabdruck … das Feld wird nicht rot umkringelt … nicht
     nach oben bewegt … es steht nicht ‚wird benötigt‘“). Ob etwas fehlt, entscheidet weiter allein der Editor (sein
     Knopf #atc-btn prüft und meldet in #atc-fehler / #cta-fehler). Erst wenn er eine Meldung zeigt, suchen wir hier die
     leeren Pflichtfelder (Kopfzeile mit Sternchen) und markieren sie: roter Rand, „Dieses Feld wird benötigt“, Scrollen
     zum ersten. Die Markierung sperrt nie selbst etwas, sie zeigt nur. Findet sie kein leeres Feld (Meldung betrifft
     z. B. den Gravur-Check), wird zur Meldung gescrollt. */
  const sichtbar = (el) => !!(el && el.offsetParent !== null && !el.closest('[hidden]'));
  /* Ein Pflichtfeld = Kopfzeile mit Sternchen und alles danach bis zur nächsten Kopfzeile (manche Editoren haben
     zwei Kopfzeilen in einem Block, z. B. „Zwischen den Buchstaben“ und „Eure Initialen“ bei der Paar-Kette). */
  function pflichtFelder() {
    if (!SP.panel) return [];
    const felder = [];
    SP.panel.querySelectorAll('.kopfzeile').forEach((kopf) => {
      const block = kopf.parentElement;
      const slot = block && block.classList.contains('abdruck-slot');
      if (!(kopf.querySelector('.pflicht-stern, .abdruck-pflicht') || slot) || !sichtbar(kopf)) return;
      const teile = [];
      for (let el = kopf.nextElementSibling; el && !el.classList.contains('kopfzeile'); el = el.nextElementSibling) teile.push(el);
      felder.push({ kopf, block, slot, teile });
    });
    return felder;
  }
  function istLeer(f) {
    const alle = (sel) => f.teile.flatMap((t) => (t.matches(sel) ? [t] : []).concat([...t.querySelectorAll(sel)]));
    if (f.slot) {
      const st = f.block.querySelector('.abdruck-status');
      return alle('input[type="file"]').every((i) => !i.files || !i.files.length) && !(st && st.textContent.trim());
    }
    const fotoStatus = alle('.jr-foto-status')[0];
    if (fotoStatus) return fotoStatus.hidden;
    const eingaben = alle('input:not([type="file"]):not([type="checkbox"]):not([type="radio"]):not([type="hidden"]), textarea, select').filter(sichtbar);
    if (eingaben.length) return eingaben.every((e) => !String(e.value || '').trim());
    const kacheln = alle('button').filter(sichtbar);
    if (kacheln.length) return !kacheln.some((b) => b.classList.contains('current') || b.getAttribute('aria-checked') === 'true');
    return false;
  }
  function markiereFehler(scrollen) {
    SP.fehlerAktiv = true;
    if (SP.panel) {
      SP.panel.querySelectorAll('.spdp-feld--fehlt').forEach((el) => el.classList.remove('spdp-feld--fehlt'));
      SP.panel.querySelectorAll('.spdp-feld-hinweis').forEach((h) => {
        if (h.previousSibling && h.previousSibling.nodeType === 3 && h.previousSibling.nodeValue === ' ') h.previousSibling.remove();
        h.remove();
      });
      SP.panel.querySelectorAll('.spdp-slot--fehlt').forEach((el) => el.classList.remove('spdp-slot--fehlt'));
    }
    let erster = null;
    pflichtFelder().forEach((f) => {
      if (!istLeer(f)) return;
      f.teile.forEach((t) => t.classList.add('spdp-feld--fehlt'));
      if (f.slot) f.block.classList.add('spdp-slot--fehlt');
      const h = document.createElement('span');
      h.className = 'spdp-feld-hinweis';
      /* Foto-Slots der Abdruck-Editoren tragen das Sternchen per ::after (schmuck-pdp.css), es stünde sonst hinter dem Hinweis */
      if (f.slot) h.innerHTML = '<span class="spdp-slot-stern" aria-hidden="true">*</span>';
      h.appendChild(document.createTextNode('Dieses Feld wird benötigt'));
      /* Leerzeichen davor: passt der Hinweis nicht mehr in die Zeile, beginnt er ohne Einzug in der nächsten */
      const vor = f.kopf.querySelector('.jr-zaehler, .abdruck-zaehler');
      f.kopf.insertBefore(document.createTextNode(' '), vor);
      f.kopf.insertBefore(h, vor);
      if (!erster) erster = f.kopf;
    });
    if (!scrollen) return;
    const ziel = erster || [...document.querySelectorAll('[data-spdp-fehler] .cta-fehler, [data-spdp-fehler] #atc-fehler')].find((el) => !el.hidden && el.textContent.trim());
    if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function beispielAnzeigen() {
    const bsp = SP.wrapBuehne && SP.wrapBuehne.querySelector('.spdp-beispiel');
    /* Dominik 25.10.: weg, sobald das erste Pflichtfeld ausgefüllt ist (nicht erst, wenn alle fertig sind) */
    if (bsp) bsp.hidden = !pflichtFelder().every(istLeer);
  }
  function editorMeldetFehler() {
    return [...document.querySelectorAll('[data-spdp-fehler] #atc-fehler, [data-spdp-fehler] #cta-fehler')].some((el) => !el.hidden && el.textContent.trim());
  }

  /* ---- Startfeld statt „Jetzt gestalten“ (25.10.2026) ----
     Dominik: „alle Schmuckprodukte genauso starten lassen wie den Fußabdruck … einfach nur den ersten Satz sehen
     (Gib deinen Ort ein), dann drückt da jemand drauf, und dann ist die Personalisierung los“. Beim Laden kommt eine
     Kopie des ersten Pflichtfelds aus der versteckten Editor-Section in den Startkasten; der schwere Editor (3D-Bühne)
     lädt erst bei der ersten Berührung. Was dort getippt, gewählt oder hochgeladen wurde, wandert danach in das echte
     Feld des Editors (gleiche Reihenfolge der Bedienelemente in Kopie und Original). Kein Startfeld gefunden = der
     Knopf „Jetzt gestalten“ bleibt wie bisher. */
  function presetWert(k) {
    try { return new URLSearchParams(window.DLEditorSearch || window.location.search).get(k); } catch (e) { return null; }
  }
  function startBlock() {
    const s = sektion();
    const sw = s && s.querySelector('.main__switcher');
    if (!sw) return null;
    const modus = presetWert('modus'), linie = presetWert('layout') === 'linie', fest = presetWert('fest');
    for (const b of sw.querySelectorAll('.elem__picker')) {
      if (b.closest('#schritt-produkt')) continue;
      if (b.id === 'zeichen-linie' && !linie) continue;
      if (b.id === 'zeichen-x' && linie) continue;
      if (b.dataset.modus && modus && b.dataset.modus !== modus) continue;
      if (b.dataset.fest === 'motiv' && fest === 'motiv') continue;
      const freigeschaltet = b.id === 'zeichen-linie' || (b.dataset.modus && b.dataset.modus === modus);
      if (b.hidden && !freigeschaltet) continue;
      const versteckt = b.parentElement && b.parentElement.closest('[hidden]');
      if (versteckt && !versteckt.classList.contains('schritt-inhalt')) continue;
      /* Foto-Editoren (Abdruck, Handschrift, Kinderzeichnung): kein Startfeld, dort bleibt „Jetzt gestalten“
         wie vorher (Dominik 25.10.: mit nur „Foto hinzufügen“ sieht man nicht, was sich alles gestalten lässt) */
      if (b.classList.contains('abdruck-slot')) return null;
      if (b.querySelector('.kopfzeile .pflicht-stern, .kopfzeile .abdruck-pflicht')) return b;
    }
    return null;
  }
  function startfeldBauen() {
    if (SP.gestartet) return;
    const box = q('[data-spdp-start]');
    if (!box || box.querySelector('.spdp-startfeld-host')) return;
    const block = startBlock();
    const root = block && (block.closest('[class*="dm-jewelry"]'));
    if (!block || !root) return;
    const huelle = document.createElement('div');
    huelle.className = 'spdp-startfeld spdp-wrap spdp-wrap--panel ' + root.className;
    const sw = document.createElement('div');
    sw.className = 'main__switcher';
    const kopie = block.cloneNode(true);
    kopie.hidden = false;
    if (block.classList.contains('abdruck-slot')) kopie.classList.add('spdp-startfeld__slot');
    [kopie, ...kopie.querySelectorAll('[id]')].forEach((el) => el.removeAttribute('id'));
    kopie.querySelectorAll('label[for]').forEach((el) => el.removeAttribute('for'));
    sw.appendChild(kopie);
    huelle.appendChild(sw);
    const sel = 'input, textarea, select, button';
    const original = [...block.querySelectorAll(sel)];
    const paare = new Map([...kopie.querySelectorAll(sel)].map((el, i) => [el, original[i]]));
    const zuOriginal = (el) => paare.get(el);
    const uebernehmen = (k, mitFokus) => {
      const o = zuOriginal(k);
      if (!o) return;
      if (k.type === 'file') {
        if (!k.files || !k.files.length || typeof DataTransfer !== 'function') return;
        const dt = new DataTransfer();
        [...k.files].forEach((f) => dt.items.add(f));
        o.files = dt.files;
        o.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      o.value = k.value;
      o.dispatchEvent(new Event('input', { bubbles: true }));
      o.dispatchEvent(new Event('change', { bubbles: true }));
      if (mitFokus && /^(text|search|)$/.test(k.type || '') || (mitFokus && k.tagName === 'TEXTAREA')) {
        try { o.focus({ preventScroll: true }); const n = o.value.length; o.setSelectionRange(n, n); } catch (e) { /* Datum/Zeit */ }
      }
    };
    /* Nach dem Start: alle Felder der Kopie übernehmen, das zuletzt benutzte behält den Fokus */
    let zuletzt = null;
    const losUndUebernehmen = () => {
      if (SP.startfeldWartet) return;
      SP.startfeldWartet = true;
      SP.nachStart.push(() => {
        paare.forEach((o, k) => { if (k.tagName !== 'BUTTON' && (k.type === 'file' ? k.files && k.files.length : k.value !== o.value)) uebernehmen(k, k === zuletzt); });
        /* Nur angetippt, noch nichts geschrieben: der Fokus muss trotzdem ins echte Feld (sonst landet er auf body) */
        const o = zuletzt && zuOriginal(zuletzt);
        if (o && document.activeElement !== o && (zuletzt.tagName === 'TEXTAREA' || /^(text|search|)$/.test(zuletzt.type || ''))) {
          try { o.focus({ preventScroll: true }); const n = o.value.length; o.setSelectionRange(n, n); } catch (e) { /* ohne Auswahl */ }
        }
      });
      starten();
    };
    huelle.addEventListener('focusin', (e) => { if (paare.has(e.target) && e.target.tagName !== 'BUTTON' && e.target.type !== 'file') { zuletzt = e.target; losUndUebernehmen(); } });
    huelle.addEventListener('input', (e) => { if (paare.has(e.target)) { zuletzt = e.target; losUndUebernehmen(); } });
    huelle.addEventListener('change', (e) => { if (paare.has(e.target)) { zuletzt = e.target; losUndUebernehmen(); } });
    huelle.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b || !paare.has(b)) return;
      e.preventDefault();
      SP.nachStart.push(() => { const o = zuOriginal(b); if (o) o.click(); });
      losUndUebernehmen();
    });
    /* Die Kopie trägt die Klassen des Editors (gleiche Optik), die Editoren suchen ihre Wurzel aber per
       document.querySelector('.dm-jewelry--x'). Darum liegt sie in einem Shadow Root: dort greifen dieselben Stylesheets
       (kopiert), document.querySelector findet aber nur den echten Editor. */
    const host = document.createElement('div');
    host.className = 'spdp-startfeld-host';
    const sr = host.attachShadow ? host.attachShadow({ mode: 'open' }) : null;
    if (!sr) return;
    document.querySelectorAll('link[rel="stylesheet"], style').forEach((st) => sr.appendChild(st.cloneNode(true)));
    sr.appendChild(huelle);
    box.querySelectorAll('.spdp__intro, .spdp__start').forEach((el) => { el.hidden = true; });
    box.appendChild(host);
  }

  function starten() {
    if (SP.gestartet) { panelEinsetzen(); buehneEinsetzen(); return; }
    cfg();
    if (!sektion()) { fehlerZeigen('Der Editor konnte nicht geladen werden. Bitte Seite neu laden.'); return; }
    SP.gestartet = true;
    status('Gestaltung läuft', false);
    /* Reihenfolge ist wichtig: Erst die Editor-Skripte laden, damit sie ihre Section (wrap = .dm-jewelry--x) noch
       vollständig vorfinden und alle Klick-Lauscher binden. Danach die Knoten herauslösen: Lauscher bleiben dran. */
    skripteLaden();
    aufEditorWarten(() => {
      if (!teileHolen()) { fehlerZeigen('Der Editor konnte nicht geladen werden. Bitte Seite neu laden.'); return; }
      panelEinsetzen();
      buehneEinsetzen();
      setTimeout(() => {
        farbeSyncen();
        /* Einige Editoren markieren im (versteckten) Ansicht-Wähler „Rückseite“, zeigen aber vorne. Einmal sauber auf
           Vorderseite stellen, sonst dreht der Editor beim späteren Ausfüllen der Rückseite nicht mit. */
        const vorne = SP.panel && SP.panel.querySelector('.swatch[data-seite="front"]');
        if (vorne && !vorne.classList.contains('current')) vorne.click();
        const offen = SP.nachStart.splice(0);
        offen.forEach((fn) => { try { fn(); } catch (e) { console.warn('[schmuck-pdp] Startfeld', e); } });
        beispielAnzeigen();
        window.dispatchEvent(new Event('resize'));
      }, 150);
    }, 80);
  }

  /* ---- Lauscher (einmal) ---- */
  if (!SP.lauscher) {
    SP.lauscher = true;
    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-spdp-starten]');
      if (b) { e.preventDefault(); starten(); }
    });
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      cfg();
      if (!istUnserFormular(f)) return;
      e.preventDefault(); e.stopPropagation();
      if (!SP.gestartet) { starten(); fehlerZeigen('Bitte gestalte zuerst deinen Anhänger.'); return; }
      fehlerZeigen('');
      farbeSyncen();
      const atc = document.getElementById('atc-btn');
      if (!atc) { fehlerZeigen('Der Editor lädt noch, bitte einen Moment.'); return; }
      atc.click();
      /* Die Editoren prüfen im Klick synchron und schreiben ihre Meldung sofort; ein Takt Luft reicht */
      setTimeout(() => { if (editorMeldetFehler()) markiereFehler(true); }, 30);
    }, true);
    /* Während Markierungen stehen: bei jeder Eingabe neu prüfen, ausgefüllte Felder werden sofort wieder normal */
    const nachpruefen = (e) => {
      if (!SP.panel || !SP.panel.contains(e.target)) return;
      setTimeout(() => { beispielAnzeigen(); if (SP.fehlerAktiv) markiereFehler(false); }, 0);
    };
    document.addEventListener('input', nachpruefen);
    document.addEventListener('change', nachpruefen);
    document.addEventListener('click', nachpruefen);
    /* 25.10.2026 (Dominik: „sobald ich in die Widmung reinklicke, sollte sich der Coin schon wieder umdrehen, so wie es
       vorher auch schon war“): auf der Gestalten-Seite drehte der Schrittwechsel die Bühne (Schritt Text = hinten). Auf der
       Produktseite sind alle Schritte gleichzeitig offen, darum dreht hier jedes benutzte Feld zu seiner Seite: Schritt
       text/rueckseite = hinten, alle anderen = vorne. Die gemeinsame Rückseite (data-jr-host) dreht selbst, Farbe und
       Produkt-Schritt gelten für beide Seiten. Gedreht wird über die (versteckte) Ansicht-Kachel des Editors. */
    const seiteVon = (el) => {
      if (!SP.panel || !el || !el.closest || !SP.panel.contains(el)) return null;
      if (el.closest('[data-jr-host], #schritt-produkt, .swatch[data-seite], .swatch[data-farbe]')) return null;
      const schritt = el.closest('.schritt-inhalt');
      if (!schritt) return null;
      return /^schritt-(text|rueckseite)$/.test(schritt.id) ? 'back' : 'front';
    };
    const zuSeiteDrehen = (e) => {
      const t = e.target;
      if (e.type === 'click' && !(t.closest && t.closest('button, label, a'))) return;
      if (e.type === 'focusin' && !(t.matches && t.matches('input, textarea, select'))) return;
      const seite = seiteVon(t);
      if (!seite) return;
      setTimeout(() => {
        const aktiv = SP.panel.querySelector('.swatch[data-seite].current');
        if (aktiv && aktiv.dataset.seite === seite) return;
        const sw = SP.panel.querySelector('.swatch[data-seite="' + seite + '"]');
        if (sw) sw.click();
      }, 0);
    };
    document.addEventListener('focusin', zuSeiteDrehen);
    document.addEventListener('click', zuSeiteDrehen);
    document.addEventListener('variant:change', () => setTimeout(() => { if (SP.gestartet) { panelEinsetzen(); buehneEinsetzen(); farbeSyncen(); } }, 0));
    new MutationObserver(() => {
      if (SP.raf) return;
      SP.raf = true;
      requestAnimationFrame(() => {
        SP.raf = false;
        if (!SP.gestartet) { startfeldBauen(); return; }
        const c = container();
        if (c && SP.wrapPanel && SP.wrapPanel.parentNode !== c) panelEinsetzen();
        if (SP.wrapBuehne && !SP.wrapBuehne.isConnected) buehneEinsetzen();
      });
    }).observe(document.body, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startfeldBauen); else startfeldBauen();
    /* PROJ-99: Bearbeiten aus dem Warenkorb landet mit ?edit= hier -> sofort starten */
    if (/[?&]edit=/.test(location.search)) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten); else starten(); }
  }
})();

/* Dev-Push 2026-10-24 14:55 (CDN-Digest hing hinterher) */
